module.exports = __webpack_public_path__ + "assets/img/play-free-now-hover.fa76f3cd.png";